import { Fragment, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch } from "react-redux";

import { sendError } from "../errors.js";
import profileApi from "../api/profile";
import { renderHtml } from "../helpers.js";
import { setLoading } from "../store/uiSlice.js";

import i18n from "../i18n.js";
import Button from "./Button.jsx";
import Icon from "./Icon.jsx";

export default function TaskListAddition({ ctas, tasks }) {
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const showFindWork =
    ctas.cta_main !== "start_relocation" &&
    tasks.find(({ id }) => id === "pre_assessment")?.done;

  useEffect(async () => {
    if (!showFindWork) return;

    dispatch(setLoading(true));
    let result;
    try {
      result = await profileApi.me();
      setData(result);
    } catch (err) {
      sendError(err);
    }
    dispatch(setLoading(false));
  }, []);

  if (showFindWork) {
    const showVerfiyAction = !ctas.cta_verify_degree && data.showVerifyDegree;

    return (
      <section class="mt-96 text-center">
        <Icon class="mb-48">clock</Icon>

        <h2 class="t-subtitle1 t-subtitle1--margin">
          {i18n.t("component.task_list_addition.title")}
        </h2>
        <p class="t-body3 color-shades-grey mb-48">
          {i18n.t(
            showVerfiyAction
              ? "component.task_list_addition.description"
              : "component.task_list_addition.description_wo_verify"
          )}
        </p>
        <div>
          {showVerfiyAction && (
            <Button
              secondary
              sameWindow
              data-native
              href="/app/tasks/statement_of_comparability?cta_verify_degree=true"
              class="mr-24"
            >
              {i18n.t("actions.verify_degree")}
            </Button>
          )}
          <Button to="/whitepaper">{i18n.t("actions.visit_whitepaper")}</Button>

          {false && (
            <p class="t-body3 color-shades-grey mt-96 mb-48">
              {renderHtml(i18n.t("component.task_list_addition.found_job"))}
            </p>
          )}
          {false && (
            <Button
              text
              sameWindow
              data-native
              href="/app?cta_main=start_relocating"
              class="mr-24"
            >
              {i18n.t("actions.start_relocating")}
            </Button>
          )}
        </div>
      </section>
    );
  }
  return null;
}
